import React from 'react';
import { isEmpty, isNil } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import shortenLevel from 'helpers/text/shortenLevel';
import {
  HOTS_CURR_ID,
  AGE_GROUP,
  CREATOR_SERIES_CURR_ID
} from 'constants/hotsCurr';

import { selectLevel } from 'stores/levels/actions';
import { setShowTrialPopup } from 'stores/login/actions';

const SidebarLevels = () => {
  const { t } = useTranslation(['common']);
  
  const dispatch = useDispatch();
  const history = useHistory();
  // const levels = useSelector(state => state.levels.levels ?? []);
  const { isTrialExpired, isTrial } = useSelector(state => state.login);
  const selectedLevel = useSelector(state => state.levels.selectedLevel ?? {});
  const { selectedCurriculum } = useSelector(state => state.curriculums);
  const currLevels =
    selectedCurriculum && selectedCurriculum.Levels
      ? selectedCurriculum.Levels
      : [];

  const isHOTS = selectedCurriculum?.CurriculumID === HOTS_CURR_ID;
  const isCreatorSeries =
    selectedCurriculum?.CurriculumID === CREATOR_SERIES_CURR_ID;

  const onSelectLevel = e => {
    const checkLevelAvailable =
      isEmpty(selectedCurriculum.Levels) &&
      selectedCurriculum.Levels.findIndex(item => item.ID === selectedLevel.ID);

    const level =
      checkLevelAvailable !== -1
        ? currLevels.find(lvl => lvl.Name === e.target.value)
        : selectedCurriculum.Levels[0];

    if (isTrialExpired && isTrial) {
      dispatch(setShowTrialPopup(true));
    } else if (!isEmpty(currLevels)) {
      history.push('/browse-content');
      dispatch(selectLevel(level));
    }
  };
  const templateLabel = (item, isShorten) => {
    if (isHOTS) {
      return `${t(`common:age`, 'Age')} ${AGE_GROUP[item.ID]}`;
    }
    if (isCreatorSeries) {
      return `${t(`common:realWorldChallenge`, 'Real-World Challenge')}`;
    }
    return isShorten ? shortenLevel(item.Name) : item.Name;
  };

  return (
    <div className="sidebar-level">
      <ul className="d-none d-lg-block">
        {currLevels.map((item, index) => (
          <li
            key={String(index)}
            className={selectedLevel.ID === item.ID ? 'active' : ''}
          >
            <a
              href="#noredirect"
              onClick={e => {
                e.preventDefault();
                if (isTrialExpired && isTrial) {
                  dispatch(setShowTrialPopup(true));
                } else {
                  if (selectedLevel.ID !== item.ID)
                    history.push('/browse-content');
                  dispatch(selectLevel(item));
                }
              }}
              style={{ fontSize: isCreatorSeries ? '10.5px' : '14px' }}
            >
              {templateLabel(item, true)}
            </a>
          </li>
        ))}
      </ul>
      <div className="row align-items-center d-flex d-lg-none">
        <div className="col-auto col-sidebar-label">
          {/* eslint-disable-next-line */}
          <label>Level</label>
        </div>
        <div className="col">
          <select
            className="form-control"
            onChange={onSelectLevel}
            onBlur={onSelectLevel}
            value={
              !isNil(selectedLevel) ? selectedLevel.Name : currLevels[0].Name
            }
          >
            {currLevels.map((item, index) => (
              <option key={String(index)}>{templateLabel(item, false)}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SidebarLevels;
